import isString from 'lodash/isString';

const getReversedArray = (isReversed: boolean, item: [string | number, string | number]) =>
  isReversed ? [item[0], item[1]] : [item[1], item[0]];

export const getOptions = (
  entries: [string | number, string | number][] | string[],
  isReversed: boolean = false,
  transformLabel = (l: string): string => l,
) => {
  return entries.map(item => {
    if (isString(item)) {
      return { value: item, label: transformLabel(item.toString()) };
    }

    const [label, value] = getReversedArray(isReversed, item);

    return { value, label: transformLabel(label.toString()) };
  });
};

export type ReturnOptionsType = (
  | { label: string; value: string }
  | { label: string; value: string | number }
)[];
